// ExportTab.js
import React, { useEffect, useState } from 'react';
import { getToken } from '../../../utils/TokenUtils';
import { API_URL } from '../../../constants/api';

export default function ExportTab({ table }) {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);

  const token = getToken(); // Or get it from auth context

  useEffect(() => {
    try {
      fetch(`${API_URL}/api/sql/tables/${table}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          setColumns(res.columns);
          setData(res.rows);
        });
    } catch (err) {
      alert(err);
    }
  }, [table]);

  const exportCSV = () => {
    if (!data.length) return;

    const csvRows = [];
    csvRows.push(columns.join(',')); // Header

    for (const row of data) {
      const values = columns.map(
        (col) => `"${(row[col] ?? '').toString().replace(/"/g, '""')}"`
      );
      csvRows.push(values.join(','));
    }

    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${table}-export.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!columns.length) return <p>Loading export options...</p>;

  return (
    <div>
      <p>
        Export data from <strong>{table}</strong>.
      </p>
      <button className="btn btn-success" onClick={exportCSV}>
        Export to CSV
      </button>
    </div>
  );
}
